import { render, staticRenderFns } from "./fandomTable.vue?vue&type=template&id=7c20a196&"
import script from "./fandomTable.vue?vue&type=script&lang=js&"
export * from "./fandomTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports